import actions from './actions';
import mutations from './mutations';

// state initial values
const state = {
  // #region : Enums :
  systemTypes: {
    AUDIO: 'Audio',
    VIDEO: 'Video',
    LIGHTING: 'Lighting'
  },
  subsystemTypes: {
    CONSOLE: 'Console',
    SPEAKERS: 'Speakers',
    MICROPHONES: 'Microphones'
  },
  stepStatuses: {
    NONE: 'None',
    VALID: 'Valid',
    WARNING: 'Warning',
    ERROR: 'Error'
  },
  // #endregion

  // #region : Loading/Saving Flags :
  productLoading: false,
  availableSubsystemsLoading: false,
  projectsLoading: false,
  systemsLoading: false,
  subsystemsLoading: false,
  componentsLoading: false,
  currentProjectLoading: false,
  currentSystemLoading: false,
  currentSubsystemLoading: false,
  savingNewProject: false,
  savingNewSystem: false,
  savingNewSubsystem: false,
  accessoryLoading: false,
  isValidatingComponent: false,
  isRefreshingTreeSummaryData: false,
  isLoadingSubsystemSteps: false,
  isLoadingStepComponent: false,
  isLoadingSubsystem: false,
  isLoadingSystem: false,
  // #endregion

  // #region : Dialogs :
  showOverlay: false,
  createSystemDialog: false,
  createSubsystemDialog: false,
  showCreateNewProjectDialog: false,
  // #endregion

  // #region : Entities/Lists :
  availableSystemDefinitions: [],
  availableSubsystemDefinitions: [],
  projectSettingDefinitions: [],
  projects: [],
  systems: [],
  subsystems: {},
  components: [],
  currentProject: null,
  currentSystem: null,
  currentSubsystem: null,
  currentSubsystemSteps: [],
  currentSubsystemStepComponent: null,
  // #endregion

  subsystemKey: 0,
  requestedStepIndex: null,
  productSortBy: 'priceasc'
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
